
export default {
  props: {
    DETAILS: Object,
  },
};
